import BaseLogDBService from "../../db-services/baseLogDBService";
import { ILogResponseModel } from "../types";


class BaseLogService {
    private dbService;

    constructor() {
        this.dbService = new BaseLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default BaseLogService;
